/*
 * @Description: 
 * @version: 
 * @Author: 小六
 * @Date: 2022-04-20 09:53:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-25 16:32:07
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js